import React, { useEffect, useMemo, useState } from 'react';
import LoaderInline from '../../components/Loader/LoaderInline';
import PDF from '../../components/Pdf';
import { useParams } from 'react-router-dom';
import getClientDocuments from '../../api/clients/getClientDocuments';
import { DOCUMENT_TYPES_CONTRACT, DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT, apiUrl } from '../../constants';
import Button from '../../components/Button/Button';
import generateContractBlank from '../../api/clients/generateContractBlank';
import Modal from '../../components/Modal/Modal';
import Input from '../../components/Input/Input';
import HookForm from '../../components/HookForm/HookForm';
import sendVerifyCode from '../../api/resources/sendVerifyCode';
import getClients from '../../api/clients/getClients';
import accessVerifyCode from '../../api/resources/accessVerifyCode';
import alert from '../../helpers/alert';
import signAllDocumentsInDealByType from '../../api/bmg/approveProccess';
import axios from 'axios';
import Checkbox from '../../components/Inputs/Checkbox/Checkbox';
import { ECP_RESEND_SECONDS, formatLeft, readStartedAt, rememberStart, secondsLeft } from './ecpResendGuard';
export const SIGN_TYPES = {
  OTP: 2,
  ECP: 1,
};

const START_DOCUMENT_INDEX = 1;
const TIMEOUT_FOR_RESEND = 30;

const SignDocuments = () => {
  const { clientId, signUrl, signType, dealId } = useParams();

  const [phone, setPhone] = useState(null);
  const [finished, setFinished] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [documentHtml, setDocumentHtml] = useState(null);
  const [fatalError, setFatalError] = useState(null);
  const [countDown, setCountDown] = useState(TIMEOUT_FOR_RESEND);
  const [agree, setAgree] = useState(false);
  // ÐÑÑÑÑÑ Ð´Ð¾ ÑÐ»ÐµÐ´ÑÑÑÐµÐ³Ð¾ Ð¿ÐµÑÐµÑÐ¾Ð´Ð° Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ Ð­Ð¦Ð â ÑÐ¼. ecpResendGuard.
  const [ecpWait, setEcpWait] = useState(() =>
    Number(signType) === SIGN_TYPES.ECP ? secondsLeft(readStartedAt(signUrl)) : 0
  );
  const state = useMemo(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const state = urlParams.get('state');
      const stateJson = JSON.parse(state);

      return stateJson;
    } catch (e) {
      return {};
    }
  }, []);

  useEffect(() => {
    if (state?.typeId === DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT) {
      const banks = typeof state?.banks === 'string' ? JSON.parse(state.banks) : state?.banks;
      const parsed = banks || [];
      setDocuments(parsed);
      setPage(parsed.length > 0 ? 0 : null);
    } else {
      setPage(0);
    }
  }, [clientId]);

  const [page, setPage] = useState(null);
  const goToPage = (inc) => {
    setPage((prev) => prev + inc);
  };

  const getDocumentHtml = () => {
    const orderIds = state?.orderIds;

    if (!orderIds) {
      setFatalError(true);
      alert.error('ÐÐµ Ð½Ð°Ð¹Ð´ÐµÐ½ ÑÐ¿Ð¸ÑÐ¾Ðº Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² Ð´Ð»Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ');
      return;
    }
    setLoading(true);
    setFatalError(false);
    // Ð¡ÑÑÐ»ÐºÑ Ð½Ð° ÑÐµÐºÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ° ÑÐ¾Ð±Ð¸ÑÐ°ÐµÐ¼ ÑÐ°Ð¼Ð¸: generateContractBlank Ð¿Ð¾Ð¼Ð¸Ð¼Ð¾ Ð½ÐµÑ
    // Ð³ÐµÐ½ÐµÑÐ¸ÑÑÐµÑ PDF-Ð±Ð»Ð°Ð½Ðº (~7 Ñ Ð½Ð° ÐºÐ°Ð¶Ð´ÑÐ¹ Ð±Ð°Ð½Ðº), ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÑÑÐ¾Ð¹ ÑÑÑÐ°Ð½Ð¸ÑÐµ Ð½Ðµ Ð½ÑÐ¶ÐµÐ½.
    // userId Ð² ÑÑÑÐ»ÐºÐµ â Ð²Ð»Ð°Ð´ÐµÐ»ÐµÑ Ð·Ð°ÐºÐ°Ð·Ð¾Ð², Ð¾Ð½ Ð¶Ðµ clientId Ð¸Ð· ÑÑÑÐ»ÐºÐ¸ Ð½Ð° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ.
    const documentTypeId = state?.typeId || DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT;
    const blank = clientId
      ? Promise.resolve({
          data: JSON.stringify({
            ru: `${apiUrl}/api/views?orderIds=${JSON.stringify(orderIds)}&userId=${clientId}&lang=ru&documentTypeId=${documentTypeId}`,
          }),
        })
      : generateContractBlank({ orderIds: orderIds, documentTypeId });
    blank
      .then((res) => {
        try {
          const link = JSON.parse(res.data)?.ru;
          axios
            .get(link, {
              params: {
                index: state?.typeId === DOCUMENT_TYPES_CONTRACT ? null : (documents?.[page] || page),
              },
            })
            .then((res) => {
              setDocumentHtml(res.data?.template || res.data);
            })
            .catch(() => {
              throw new Error();
            })
            .finally(() => {
              setLoading(false);
            });
        } catch (e) {
          alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ');
          setFatalError(true);
          setLoading(false);
          console.log(e);
        }
      })
      .catch(() => {
        setFatalError(true);
        alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ');
        setLoading(false);
      });
  };

  useEffect(() => {
    if (page === null) return;
    getDocumentHtml();
  }, [page]);
  // Ð¢Ð¸ÐºÐ°ÐµÐ¼, Ð¿Ð¾ÐºÐ° Ð¸Ð´ÑÑ Ð¾Ð¶Ð¸Ð´Ð°Ð½Ð¸Ðµ: ÐºÐ»Ð¸ÐµÐ½Ñ Ð²ÐµÑÐ½ÑÐ»ÑÑ Â«Ð½Ð°Ð·Ð°Ð´Â» Ð¸ Ð²Ð¸Ð´Ð¸Ñ, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¾ÑÑÐ°Ð»Ð¾ÑÑ.
  useEffect(() => {
    if (ecpWait <= 0) return undefined;
    const tick = setInterval(() => setEcpWait(secondsLeft(readStartedAt(signUrl))), 1000);
    return () => clearInterval(tick);
  }, [ecpWait, signUrl]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const success = urlParams.get('success');
    setPhone(state?.phone);
    if (success) {
      setFinished(true);
    }
  }, []);

  const [countDownInterval, setCountDownInterval] = useState(null);
  const sendSms = () => {
    return new Promise((resolve, reject) => {
      sendVerifyCode({
        phone,
        dealId,
      })
        .then(() => {
          clearInterval(countDownInterval);
          setCountDown(TIMEOUT_FOR_RESEND);

          const interval = setInterval(() => {
            setCountDown((prev) => {
              if (prev === 0) {
                clearInterval(countDownInterval);
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
          setCountDownInterval(interval);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  };

  const sign = () => {
    setLoading(true);
    if (signType == SIGN_TYPES.OTP) {
      sendSms()
        .then(() => {
          setIsModalOpen(true);
        })
        .catch(() => {
          alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð¡ÐÐ¡');
        })
        .finally(() => setLoading(false));
    }

    if (signType == SIGN_TYPES.ECP) {
      // ÐÐ°Ð¶Ð´ÑÐ¹ Ð¿ÐµÑÐµÑÐ¾Ð´ â Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐ¹ Ð·Ð°Ð¿ÑÐ¾Ñ ÐºÐ¾Ð´Ð° Ñ ÑÐµÑÐ²Ð¸ÑÐ° Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ
      // Ð¾ÑÐ¼ÐµÑÐ°ÐµÐ¼ Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð´Ð¾ ÑÑÐ¾Ð´Ð°: Ð²ÐµÑÐ½ÑÑÑÑ ÐºÐ»Ð¸ÐµÐ½Ñ â ÑÐ²Ð¸Ð´Ð¸Ñ Ð¾ÑÑÑÑÑ, Ð° Ð½Ðµ ÐºÐ½Ð¾Ð¿ÐºÑ.
      rememberStart(signUrl);
      setEcpWait(ECP_RESEND_SECONDS);
      window.location.href = apiUrl + '/p/' + signUrl;
    }
  };

  const resendSms = (e) => {
    e.preventDefault();
    sendSms();
  };

  const checkCode = (values) => {
    setLoadingModal(true);
    accessVerifyCode({
      phone,
      code: values.code,
      dealId,
    })
      ?.then((res) => {
        if (res?.data) {
          const dealId = state?.dealId;

          if (!dealId) {
            alert.error('ÐÐµ Ð½Ð°Ð¹Ð´ÐµÐ½ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾Ñ ÑÐ´ÐµÐ»ÐºÐ¸');
            return;
          }
          signAllDocumentsInDealByType({
            dealId,
            documentTypeId: DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT,
            userId: clientId,
          })
            .then((res) => {
              setFinished(true);
              window.history.replaceState(
                {},
                document.title,
                '?' + window.location.href.split('?')?.[1] + '&success=true'
              );
            })
            .catch(() => {
              alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ');
            })
            .finally(() => {
              setLoadingModal(false);
            });
        } else {
          alert.error('ÐÐµÐ²ÐµÑÐ½ÑÐ¹ ÐºÐ¾Ð´');
          setLoadingModal(false);
        }
      })
      .catch(() => {
        setLoadingModal(false);
      });
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '90vh',
        }}
      >
        <LoaderInline />
      </div>
    );
  }

  if (fatalError) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '90vh',
          flexDirection: 'column',
          gap: 30,
        }}
      >
        <h1>ÐÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð½ÐµÐ¿ÑÐµÐ´Ð²Ð¸Ð´ÐµÐ½Ð½Ð°Ñ Ð¾ÑÐ¸Ð±ÐºÐ°</h1>
        <Button text={'ÐÐ¾Ð¿ÑÐ¾Ð±Ð¾Ð²Ð°ÑÑ ÐµÑÐµ ÑÐ°Ð·'} fill onClick={getDocumentHtml} />
      </div>
    );
  }

  if (finished) {
    return (
      <div
        style={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 30,
          fontWeight: 700,
          fontSize: 20,
          color: '#05141F',
          padding: '80px 20px',
        }}
      >
        <p>Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»ÑÐ½ÑÑ Ð´Ð°Ð½Ð½ÑÑ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ñ</p>
        <svg width="201" height="202" viewBox="0 0 201 202" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100.507 0.247314V16.2899C89.1068 16.2899 78.0471 18.5245 67.6411 22.9203C62.6383 25.0349 57.8155 27.6564 53.2996 30.7048C48.8237 33.7265 44.6212 37.1952 40.799 41.0174C36.9769 44.8396 33.5082 49.0487 30.4865 53.5179C27.438 58.0338 24.8165 62.8566 22.702 67.8595C18.2995 78.2655 16.0715 89.3185 16.0715 100.725C16.0715 112.125 18.3061 123.185 22.702 133.591C24.8165 138.593 27.438 143.416 30.4865 147.932C33.5082 152.408 36.9769 156.61 40.799 160.433C44.6212 164.255 48.8303 167.723 53.2996 170.745C57.8155 173.794 62.6383 176.415 67.6411 178.53C78.0471 182.932 89.1001 185.16 100.507 185.16C111.907 185.16 122.966 182.926 133.372 178.53C138.375 176.415 143.198 173.794 147.714 170.745C152.19 167.723 156.392 164.255 160.214 160.433C164.036 156.61 167.505 152.401 170.527 147.932C173.575 143.416 176.197 138.593 178.311 133.591C182.714 123.185 184.942 112.132 184.942 100.725H200.984C200.984 107.536 200.297 114.346 198.943 120.97C197.622 127.427 195.648 133.777 193.086 139.841C190.565 145.798 187.45 151.541 183.821 156.911C180.226 162.227 176.103 167.23 171.554 171.779C167.012 176.322 162.009 180.451 156.686 184.046C151.316 187.675 145.573 190.79 139.616 193.312C133.546 195.88 127.202 197.847 120.745 199.168C114.128 200.522 107.317 201.209 100.5 201.209C93.6894 201.209 86.8788 200.522 80.255 199.168C73.798 197.847 67.4477 195.873 61.3842 193.312C55.4274 190.79 49.6841 187.675 44.3144 184.046C38.998 180.451 33.9951 176.328 29.4459 171.779C24.9032 167.237 20.7742 162.234 17.1788 156.911C13.5501 151.541 10.4349 145.798 7.9135 139.841C5.34535 133.771 3.37755 127.427 2.0568 120.97C0.702685 114.353 0.015625 107.542 0.015625 100.725C0.015625 93.9144 0.702685 87.1039 2.0568 80.4801C3.37755 74.023 5.35202 67.6727 7.9135 61.6092C10.4349 55.6525 13.5501 49.9092 17.1788 44.5394C20.7742 39.223 24.8966 34.2202 29.4459 29.6709C33.9951 25.1216 38.9913 20.9992 44.3144 17.4038C49.6841 13.7751 55.4274 10.66 61.3842 8.13851C67.4544 5.57037 73.798 3.60257 80.255 2.28181C86.8855 0.934372 93.6961 0.247314 100.507 0.247314Z"
            fill="#BABABA"
          />
          <path
            d="M96.7916 106.922L69.5226 79.6529L50.3916 98.7905L96.7916 145.191L102.535 139.454L115.929 126.06L169.854 72.1285L150.716 52.9976L96.7916 106.922Z"
            fill="var(--brand-primary)"
          />
          <path
            d="M119.222 12.82C121.582 10.4599 121.582 6.63338 119.222 4.27328C116.862 1.91318 113.036 1.91319 110.676 4.27329C108.316 6.63339 108.316 10.4599 110.676 12.82C113.036 15.1801 116.862 15.1801 119.222 12.82Z"
            fill="#BABABA"
          />
        </svg>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '0 15px',
        width: '100%',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column'
      }}
      className='documentContainer'
    >
      <h1
        style={{
          margin: '20px 0',
        }}
      >
        ÐÐ½Ð¸Ð¼Ð°ÑÐµÐ»ÑÐ½Ð¾ Ð¾Ð·Ð½Ð°ÐºÐ¾Ð¼ÑÑÐµÑÑ Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°Ð¼Ð¸ Ð¸ Ð¿ÐµÑÐµÐ¹Ð´Ð¸ÑÐµ Ðº Ð¸Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ
      </h1>
      <div
        style={{
          position: 'relative',
          flex: 1,

          overflow: 'auto',
        }}
      >
        {/* {documents.map((item, idx) => {
          return <>{idx === page - 1 && <PDF url={item.url} />}</>;
        })} */}
        {/* pass html into div */}
        <div
          dangerouslySetInnerHTML={{ __html: documentHtml }}
          style={{
            lineHeight: '1.5',
          }}
        />
      </div>
      {state?.typeId == DOCUMENT_TYPES_PERSONAL_DATA_AGREEMENT ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            paddingTop: 20,
          }}
        >
          <Button
            fill
            text={'ÐÑÐµÐ´ÑÐ´ÑÑÐ¸Ð¹ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ'}
            onClick={() => goToPage(-1)}
            disabled={page === 0}
          />
          <Button fill text={'Ð¡Ð»ÐµÐ´ÑÑÑÐ¸Ð¹ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ'} onClick={() => goToPage(1)} disabled={page === documents.length - 1} />
        </div>
      ) : null}
      <div style={{ marginTop: '20px' }}>
        <Checkbox
          id="agree"
          value={agree}
          onChange={(id, value) => setAgree(value)}
          label="ÐÐ·Ð½Ð°ÐºÐ¾Ð¼Ð»ÐµÐ½ Ð¸ ÑÐ¾Ð³Ð»Ð°ÑÐµÐ½ Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°Ð¼Ð¸"
        />
      </div>
      <div style={{ margin: '20px 0' }}>
        <Button
          fill
          full
          text={ecpWait > 0 ? `ÐÐ¾Ð´ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½, Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ ÑÐµÑÐµÐ· ${formatLeft(ecpWait)}` : 'ÐÐµÑÐµÐ¹ÑÐ¸ Ðº Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ'}
          onClick={sign}
          disabled={!agree || ecpWait > 0}
        />
        {ecpWait > 0 ? (
          <p style={{ textAlign: 'center', marginTop: 10, color: '#6b7280' }}>
            ÐÐ¾Ð´ Ð¿ÑÐ¸Ð´ÑÑ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐ¼ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸ÐµÐ¼ Ð² ÑÐµÑÐµÐ½Ð¸Ðµ Ð¼Ð¸Ð½ÑÑÑ. ÐÐµ Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð¹ÑÐµ ÐµÐ³Ð¾ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾ â ÑÐµÑÐ²Ð¸Ñ
            Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾ Ð¿ÐµÑÐµÑÑÐ°ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÑÑ ÐºÐ¾Ð´.
          </p>
        ) : null}
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        width="100%"
        contentStyle={{
          maxWidth: 600,
          height: 'max-content',
          inset: '100px 0 0 0',
          width: '100%',
        }}
        overlayStyle={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {loadingModal ? (
          <LoaderInline />
        ) : (
          <HookForm
            title="ÐÐ²ÐµÐ´Ð¸ÑÐµ ÐºÐ¾Ð´ Ð¸Ð· Ð¡ÐÐ¡ Ð´Ð»Ñ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°"
            grid={{
              display: 'grid',
              gap: '10px',
              gridTemplateColumns: '1fr',
            }}
            onSubmit={checkCode}
            inputs={[
              {
                name: 'code',
                label: 'ÐÐ¾Ð´ Ð¸Ð· Ð¡ÐÐ¡',
                type: 'text',
                required: true,
                rules: {
                  required: true,
                },
                validate: (value) => {
                  if (value.length !== 4) {
                    return 'ÐÐµÐ²ÐµÑÐ½ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ ÐºÐ¾Ð´Ð°';
                  }
                  return true;
                },
              },
            ]}
            customData={(submit) => (
              <>
                {countDown ? (
                  <p style={{ textAlign: 'center' }}>ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐºÐ¾Ð´ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾ ÑÐµÑÐµÐ· {countDown} ÑÐµÐºÑÐ½Ð´</p>
                ) : (
                  <Button text={'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÐºÐ¾Ð´ Ð¿Ð¾Ð²ÑÐ¾ÑÐ½Ð¾'} onClick={resendSms} />
                )}

                <Button text="ÐÐ¾Ð´Ð¿Ð¸ÑÐ°ÑÑ" fill full onClick={submit} />
              </>
            )}
          />
        )}
      </Modal>
    </div>
  );
};

export default SignDocuments;
